import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  memberGroups: [],
  loading: false,
};

const memberGroupSlice = createSlice({
  name: "memberGroups",
  initialState,
  reducers: {
    setMemberGroups: (state, action) => {
      state.memberGroups = action.payload || [];
    },
    addMemberGroup: (state, action) => {
      const group = action.payload;
      if (!group?._id) return;
      const exists = state.memberGroups.some((item) => String(item._id) === String(group._id));
      if (!exists) state.memberGroups.push(group);
    },
    updateMemberGroup: (state, action) => {
      const group = action.payload;
      if (!group?._id) return;
      state.memberGroups = state.memberGroups.map((item) =>
        String(item._id) === String(group._id) ? group : item
      );
    },
    removeMemberGroup: (state, action) => {
      const groupId = action.payload;
      state.memberGroups = state.memberGroups.filter((item) => String(item._id) !== String(groupId));
    },
    setMemberGroupsLoading: (state, action) => {
      state.loading = Boolean(action.payload);
    },
    clearMemberGroups: () => initialState,
  },
});

export const {
  setMemberGroups,
  addMemberGroup,
  updateMemberGroup,
  removeMemberGroup,
  setMemberGroupsLoading,
  clearMemberGroups,
} = memberGroupSlice.actions;

export default memberGroupSlice.reducer;